import axios from "axios";
import { Base_URL } from "../url";

export const getAllItemGroups = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ItemGroupMaster/GetAllItemGroups`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching item groups!";
  }
};

export const getItemGroups1ByItemGroupCode = async (itemGroupCode) => {
  try {
    const response = await axios.post(
      `${Base_URL}/ItemGroup1/GetItemGroupsByItemGroupCode`,
      { itemGroupCode }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching item groups 1!";
  }
};

export const getItemGroups2ByItemGroup1 = async (itemGroup1) => {
  try {
    const response = await axios.post(
      `${Base_URL}/ItemGroup2/GetItemGroups2ByItemGroup1`,
      { itemGroup1 }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching item groups 2!";
  }
};

export const saveItemGroup3 = async (itemGroupData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/ItemGroup3/ItemGroup3?UserName=${userName}`,
      itemGroupData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving item group 3!";
  }
};